import React from 'react';
import { useSelector } from 'react-redux';
import conf from '../conf';
import Payment from '../components/payment';
import { PageWrapper, FlexContainerRowLRPadding } from '../components/styled/skylab/page';
import { selectState } from '../selectors';
import Banner from '../components/banner';
import BuyFlowCart from '../components/buy-flow/cart';
const PaymentPage = () => {
    const { buyFlow: { hideIframe }, system: { activeFlow, isMobile }, } = useSelector(selectState);
    const activeFlowIsAvataxBuy = activeFlow === 'avatax-buy' || activeFlow === 'avatax-direct-buy';
    return React.createElement(React.Fragment, null,
        activeFlowIsAvataxBuy && React.createElement(Banner, { backgroundImage: `${conf.ASSET_PATH}/assets/images/banner-background.png`, image: `${conf.ASSET_PATH}/assets/images/payment_w.svg`, primaryText: 'Purchase your subscription' }),
        React.createElement(PageWrapper, null,
            React.createElement(FlexContainerRowLRPadding, { offsetRight: 50, forceMobile: isMobile },
                React.createElement(Payment, { hideIframe: hideIframe }),
                React.createElement("div", null, activeFlowIsAvataxBuy && React.createElement(BuyFlowCart, { isPaymentPage: true })))));
};
export default PaymentPage;
